import { useEffect, useState } from 'react';

export const usePickerSharedValues = (disabled:boolean) => {

    const [items, setItems] = useState<any[]>([]);
    const [show, setShow] = useState(false);
    const [localValue, setLocalValue] = useState<Date | null>(null);
    const [localDisabled, setLocalDisabled] = useState(disabled);

    useEffect(() => {
        setLocalDisabled(disabled);
    }, [disabled]);
    
    return {
        items, setItems,
        show, setShow,
        localValue, setLocalValue,
        localDisabled, setLocalDisabled
    };
};
